//Labels for the chat and its conversation list: "היום" / "אתמול" / d/m/yyyy, and the time.
//A date string from the api is read the way $globals.niceDate reads it (the trailing Z dropped,
//the rest taken as local time), so the chat shows the same clock as the rest of the app.

function toDate(value) {

    if (!value)
        return null;

    if (typeof value.getMonth === 'function')
        return value;

    let date = new Date(String(value).replace(/Z$/, ''));

    return isNaN(date.getTime()) ? null : date;
}

//d/m/yyyy, no leading zeros (niceDate's format for a date string)
export function dayKey(value) {

    let date = toDate(value);

    if (!date)
        return '';

    return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
}

//h:mm
export function timeOf(value) {

    let date = toDate(value);

    if (!date)
        return '';

    return date.getHours() + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
}

//"היום" / "אתמול" / the date
export function dayLabel(value) {

    let key = dayKey(value);

    if (!key)
        return '';

    if (key == dayKey(new Date()))
        return 'היום';

    if (key == dayKey(new Date(Date.now() - 86400000)))
        return 'אתמול';

    return key;
}

//the chat header: "הודעה אחרונה היום בשעה 12:17" / "...אתמול בשעה 9:05" / "...ב-14/10/2026 בשעה 12:17"
export function lastMessageLabel(value) {

    let label = dayLabel(value);

    if (!label)
        return '';

    let when = label == dayKey(value) ? 'ב-' + label : label;

    return 'הודעה אחרונה ' + when + ' בשעה ' + timeOf(value);
}

//the conversation list: today its time, yesterday "אתמול", before that the date
export function listWhen(value) {

    let label = dayLabel(value);

    return label == 'היום' ? timeOf(value) : label;
}
